import { Box, Typography } from '@mui/material'
import ToggleButton from '@mui/material/ToggleButton'
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup'

export default function ToggleButtons({
  options,
  value,
  onChange,
  exclusive = true,
  groupAriaLabel = 'toggle button group',
  groupLabel = '',
  sx = {},
  ...otherProps
}) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        ...sx,
      }}
    >
      {groupLabel && (
        <Typography variant="overline" sx={{ mr: 1, fontWeight: 600, }}>
          {groupLabel}
        </Typography>
      )}
      <ToggleButtonGroup
        value={value}
        exclusive={exclusive}
        onChange={onChange}
        aria-label={groupAriaLabel}
        {...otherProps}
      >
        {options.map(({ value, label, icon: Icon, disabled = false, ariaLabel }) => (
          <ToggleButton
            key={value}
            value={value}
            aria-label={ariaLabel || label}
            disabled={disabled}
          >
            {Icon && <Icon />}{' '}
            <Typography variant="button" sx={{ ml: Icon ? 1 : 0 }}>
              {label}
            </Typography>
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </Box>
  )
}
